(function() {
  var overlay = document.getElementById('pc-quick-view');
  if (!overlay) return;

  var img = document.getElementById('pc-qv-img');
  var title = document.getElementById('pc-qv-title');
  var price = document.getElementById('pc-qv-price');
  var desc = document.getElementById('pc-qv-desc');
  var atcBtn = document.getElementById('pc-qv-atc');
  var viewLink = document.getElementById('pc-qv-link');
  var closeBtn = overlay.querySelector('.pc-qv-close');

  function open(handle) {
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        img.src = product.featured_image ? product.featured_image.replace(/(\.[^.]+)$/, '_600x$1') : '';
        img.alt = product.title;
        title.textContent = product.title;

        var variant = product.variants[0];
        var priceHtml = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHtml = '<span class="pc-qv-current">' + formatMoney(variant.price) + '</span> <span class="pc-qv-compare">' + formatMoney(variant.compare_at_price) + '</span>';
        } else {
          priceHtml = '<span class="pc-qv-current">' + formatMoney(variant.price) + '</span>';
        }
        price.innerHTML = priceHtml;

        desc.innerHTML = product.description ? product.description.substring(0, 200) + (product.description.length > 200 ? '...' : '') : '';
        atcBtn.setAttribute('data-variant-id', variant.id);

        if (variant.available) {
          atcBtn.textContent = 'ADD TO CART';
          atcBtn.disabled = false;
        } else {
          atcBtn.textContent = 'SOLD OUT';
          atcBtn.disabled = true;
        }

        viewLink.href = '/products/' + handle;
        overlay.classList.add('pc-qv--active');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
  }

  function close() {
    overlay.classList.remove('pc-qv--active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    return '\u00a3' + (cents / 100).toFixed(2);
  }

  // Close handlers
  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') close();
  });

  // Open handler (delegated)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.pc-qv-btn');
    if (btn) {
      e.preventDefault();
      open(btn.getAttribute('data-handle'));
    }
  });

  // ATC in modal
  atcBtn.addEventListener('click', function() {
    var variantId = this.getAttribute('data-variant-id');
    if (!variantId || this.disabled) return;
    this.textContent = 'ADDING...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      atcBtn.textContent = 'ADDED \u2713';
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      });
      setTimeout(function() {
        atcBtn.textContent = 'ADD TO CART';
        close();
      }, 1500);
    })
    .catch(function() {
      atcBtn.textContent = 'ADD TO CART';
    });
  });
})();
